import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientInstanceService } from 'src/app/core/services/client-instance.service';
import { EnvironmentService } from 'src/app/core/services/environment/environment.service';

const CLIENT_ID_HEADER = 'X-Loda-Client-Id';
const WRITE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

@Injectable()
export class ClientIdInterceptor implements HttpInterceptor {
  constructor(
    private readonly _clientInstanceService: ClientInstanceService,
    private readonly _environmentService: EnvironmentService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.shouldAddClientId(request)) {
      return next.handle(request);
    }

    return next.handle(request.clone({
      setHeaders: {
        [CLIENT_ID_HEADER]: this._clientInstanceService.clientId
      }
    }));
  }

  private shouldAddClientId(request: HttpRequest<unknown>): boolean {
    if (!WRITE_METHODS.has(request.method.toUpperCase()) || request.headers.has(CLIENT_ID_HEADER)) {
      return false;
    }

    const requestUrl = request.url.toLowerCase();
    return this.getApiBaseUrls().some(apiBaseUrl => {
      const normalizedBaseUrl = apiBaseUrl.trim().toLowerCase().replace(/\/+$/, '');
      return normalizedBaseUrl.length > 0
        && (requestUrl === normalizedBaseUrl || requestUrl.startsWith(`${normalizedBaseUrl}/`));
    });
  }

  private getApiBaseUrls(): string[] {
    const apiInfo = this._environmentService.apiInfo;
    return [
      apiInfo.apiBaseUrl,
      apiInfo.authApiBaseUrl,
      apiInfo.publicApiBaseUrl,
      apiInfo.docApiBaseUrl,
      apiInfo.jobApiBaseUrl,
      apiInfo.docuViewareApiBaseUrl
    ].filter((apiBaseUrl): apiBaseUrl is string => !!apiBaseUrl);
  }
}
